<template>
    <header>
        <section id="title" class="flex-row-between">
            <div class="logo">
                <a :href="loginUrl">
                    <h1 hidden>Boston Scientific 표준통관예정보고시스템</h1>
                    <img src="../../../assets/image/service-logo-white.png" alt="">
                </a>
            </div>
            <div class="user-profile flex-row" v-if="name !== null">
                <div class="user-info text-right">
                    <p class="user-name sf-bold">{{ name }}<!--//user-name--></p>
                    <p class="user-group sf-normal">{{ team }}<!--//user-group--></p>
                    <div class="user-control">
                        <a href="/modify" class="btn btn-small bc01">정보수정</a>
                        <a href="#" class="btn btn-small" @click.prevent="logout">로그아웃</a>
                    </div>
                </div>
                <div class="user-icon">
                    <!--유저 사진을 넣는 기능이 있는지?-->
                    <!--//if user-picture!=null-->
                    <!--//img src="user-picture"-->
                    <!--//else-->
                    <div class="default-user-picture"></div>
                </div>
            </div>
        </section>
    </header>
</template>

<script>
import $ from 'jquery'

export default {
    data: () => ({
        name: sessionStorage.getItem('dvUserName'),
        team: sessionStorage.getItem('dvUserID'),
        loginUrl: `/login?redirectUrl=${location.pathname}`
    }),
    watch: {
        '$route'() {
            this.name = sessionStorage.getItem('dvUserName')
            this.team = sessionStorage.getItem('dvUserID')
            this.loginUrl = `/login?redirectUrl=${location.pathname}`
        }
    },
    methods: {
        logout() {
            let vm = this
            vm.$http.get('/api/member/logout')
                .then(({data}) => {
                    if (data.result) {
                        alert('로그아웃되었습니다.')
                        sessionStorage.clear()
                        // Clear any legacy JS-readable cookies
                        if (vm.$cookies.isKey('dvUserID')) {
                            vm.$cookies.remove('dvUserID')
                        }
                        vm.$router.push(vm.loginUrl)
                    } else if (!data.message) {
                        alert('에러가 발생했습니다.')
                    }
                })
        }
    }

}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/template/header.vue